module.exports = __webpack_public_path__ + "cdff05e126fda815ef6ea5d65dd23b22.svg";